import { Alert, Stack, TextField } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import moment from "moment";
import { useState } from "react";
import Layout from "../../../Frames/Layout";
import API from "../../../../services/API/API";

export default function List() {

    const [from, setFrom] = useState(moment().startOf('month').format('YYYY-MM-DD'));
    const [to, setTo] = useState(moment().format('YYYY-MM-DD'));
    const [loading, setLoading] = useState(null);

    const handleDownload = async format => {

        const url = API.url(`/dpc/invoices.${format}?from=${from}&to=${to}`);

        setLoading(format);
        await API.downloadFile(url, `invoices.${format}`);
        setLoading(null);
    };

    const handleSubmit = e => {
        e.preventDefault();
        handleDownload('zip');
    };

    return (
        <Layout title="Factures DPC" tab="invoices" menu="dpc">
            <Stack spacing={3} sx={{ width: 500, mx: 'auto' }}>
                <form id="dpc_invoices" onSubmit={handleSubmit}>
                    <Stack spacing={3}>
                        <TextField
                            label="Du"
                            name="from"
                            type="date"
                            value={from}
                            onChange={e => setFrom(e.target.value)}
                            size="small"
                            InputLabelProps={{ shrink: true }}
                        />
                        <TextField
                            label="Au"
                            name="to"
                            type="date"
                            value={to}
                            onChange={e => setTo(e.target.value)}
                            size="small"
                            InputLabelProps={{ shrink: true }}
                        />
                        <Stack direction="row" spacing={2}>
                            <LoadingButton
                                type="submit"
                                loading={loading === 'zip'}
                                disabled={!!loading}
                                variant="contained"
                                fullWidth
                            >
                                Télécharger les PDF
                            </LoadingButton>
                            <LoadingButton
                                type="button"
                                onClick={() => handleDownload('csv')}
                                loading={loading === 'csv'}
                                disabled={!!loading}
                                variant="outlined"
                                fullWidth
                            >
                                Télécharger le CSV
                            </LoadingButton>
                        </Stack>
                    </Stack>
                </form>

                <Alert severity="warning">
                    Attention : le téléchargement des PDF peut durer quelques minutes.
                </Alert>
            </Stack>
        </Layout>
    );
}
